const config = {
  // isMaintenance: process.env.REACT_APP_MAINTENANCE_MODE === 'true' || false,
  isMaintenance: false,

};

export default config; 